import { Link, useNavigate, useParams } from "react-router-dom";
import Logo from "../components/Logo";
import Button from "../components/Button";
import ModalPage, { CheckAnimation } from "../components/ModalPage";
import { useAuthContext } from "../providers/AuthProvider";
import { useEffect, useState } from "react";
import { format } from "date-fns";
import { useToast } from "../components/ToastProvider";

type AcceptData = {
    id: number;
    title: string;
    from: string;
    date: string;
}

const AcceptAccessInvitation = () => {
    const { apiCall } = useAuthContext();
    const { showToast } = useToast();
    const params = useParams();
    const navigate = useNavigate();

    const [data, setData] = useState<AcceptData | null>(null);
    const [view, setView] = useState(1);
    const [accepting, setAccepting] = useState(false);

    const getData = async () => {
        try {
            const response = await apiCall({
                action: 'getInvitationData',
                hash: params.hash
            });

            if (response.data.status === 200) {
                setData(response.data.data);
            } else {
                navigate('/');
            }
        } catch (error) {
            console.error(error);
        }
    }

    const handleAccept = async () => {
        setAccepting(true);
        try {
            const response = await apiCall({
                action: 'acceptAccessInvitation',
                hash: params.hash
            });

            if (response.data.status === 200) {
                setView(2);
            } else {
                showToast(response.data.message, 'danger');
                setAccepting(false);
            }
        } catch (error) {
            console.error(error);
        }
    }

    useEffect(() => {
        getData();
    }, []);

    if (!data) return false;

    return (
        <ModalPage>
            {view === 1 ? (
                <>
                    <Logo
                        contain="center"
                    />

                    <div className="text-center mt-5 mx-4">
                        <h3>Du har blitt invitert til å se søknad "{data.title}"</h3>
                        <p>{data.from} har sendt deg en invitasjon til å se/redigere søknaden. Trykk på knappen nedenfor for å akseptere.</p>
                    </div>

                    <div className="bg-light p-4 mx-5 text-start">
                        <p><span className="fw-semibold">Søknad: </span>{data.title} #{data.id}</p>
                        <p><span className="fw-semibold">Av: </span>{data.from}</p>
                        <p className="mb-0"><span className="fw-semibold">Daro: </span>{format(data.date, 'dd.MM.yyyy')}</p>
                    </div>

                    <Button
                        title="Aksepter"
                        classes="mt-3"
                        rightIcon="check"
                        onClick={handleAccept}
                        loading={accepting}
                    />

                    <p className="mt-4">
                        <Link to="/">
                            Gå til søknadsportal
                        </Link>
                    </p>
                </>
            ) : view === 2 ? (
                <>
                    <CheckAnimation />
                    <h4 className="mt-4 mb-3">Du har nå tilgang!</h4>
                    {/* <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Curabitur tellus quam, sodales vitae sapien eu, iaculis dapibus sapien.</p> */}
                    <Button 
                        title="Logg inn"
                        onClick={() => navigate('/')}
                        rightIcon="arrow-right"
                        classes="mt-3"
                    />
                </>
            ) : null}
        </ModalPage>
    );
}

export default AcceptAccessInvitation;